import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
const { PROCEDURE_15 } = environment;

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  constructor(private http: HttpClient) { }


  getDocumentTypes(jsonDocument: any): Observable<any> {
    return this.http.post(`${PROCEDURE_15}/Master/DocumentTypes`, jsonDocument);
  }


  getStatus(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Master/GetStatus`);
  }

  getProgramTypes(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Master/GetProgramTypes`);
  }


  getTitleTypes(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Master/GetTitleTypes`);
  }


  getReasonModification(personType): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Master/GetReasonsModification/${personType}`);
  }


  getTypeProfessional(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Master/GetTypeProfessional`);
  }

  getProfiles(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Master/GetProfiles`);
  }


  getAllFieldsOfAction(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Master/GetFieldsOfAction`);
  }

  getFieldsOfActionByProfile(idProfile: number): Observable<any> {
    return this.http.get(
      `${PROCEDURE_15}/Master/GetFieldsOfActionByProfile?idProfile=${idProfile}`
    );
  }


  getFieldsOfActionByPersonType(idPersonType: number): Observable<any> {
    return this.http.get(
      `${PROCEDURE_15}/Master/GetFieldsOfActionByPersonType?idPersonType=${idPersonType}`
    );
  }
}
